import React from 'react';
import {KeywordFields} from '../keywordItem.types';
import {Vkos} from './Vkos';
import {VexClusters} from './VexClusters';
import {SetOptional} from 'type-fest';
import {KeywordTooltipHeading} from './KeywordTooltipHeading';
import {useKeywordsTranslations} from '../keywords.commonHooks';

/**
 * Although the keywords should have these fields, we set them to optional
 * because many pages do not have proper type safety. This is because they cast
 * their query's types to a type that is less accurate. So, many pages wouldn't
 * show type-errors if these fields were missing. Therefore, this component must
 * handle these fields being missing. We can use @see KeywordFields directly
 * once pages have better type safety.
 */
type ExpectedKeywordFields = SetOptional<
	KeywordFields,
	'vexClusters' | 'vkos' | 'descriptions'
>;

interface Props {
	keyword: ExpectedKeywordFields;
}

export function KeywordTooltip({keyword}: Props): React.ReactElement {
	const {vexClusters = [], vkos = []} = keyword;
	const descriptions = keyword.descriptions ?? [];
	const {t} = useKeywordsTranslations();

	return (
		<div>
			<VexClusters vexClusters={vexClusters} />
			<Vkos vkos={vkos} />
			{descriptions.length > 0 && (
				<div>
					<KeywordTooltipHeading>{t('Descriptions')}</KeywordTooltipHeading>
					{descriptions.map((d, i) => (
						<div key={i}>
							<strong>{`${d.lang}: `}</strong>
							{d.translation}
						</div>
					))}
				</div>
			)}
		</div>
	);
}
